const config = {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_SxHL4WbcS",
    APP_CLIENT_ID: "kp6nduv1lbnhuv591cts68726",
    IDENTITY_POOL_ID: "us-east-1:823d4673-8498-4a3b-86f8-b6a8af86badb",
  },
};

export default config;